/**
 * Regelversion 3: Polarisierung.
 * Gesetze und Entscheidungen mit klarer Haltung bei Kulturkampf-Themen bewegen die Wählergruppen
 * gegeneinander (je nach ihrer Neigung) und erhöhen die Spaltung im Land. Hohe Spaltung mobilisiert
 * die eigene Basis, kostet aber langsam allgemeine Zustimmung.
 */
import { LEAN, POLAR } from '../content/axes3';
import { AXN } from '../content/axes';
import { S, log } from './state';
import { since } from './version';
import { clamp } from './util';

/** Stärke der Gruppenreaktion je Punkt Haltung. */
export const POL_K = 1.4;
/** Monatlicher Abzug von der Gruppenstimmung je Punkt Spaltung. */
export const POL_COST = .003;

const polar = () => (S as any).polar || 0;

/** Wirkung einer Haltung zu Kulturkampf-Themen auf Gruppen und Spaltung. Gibt die Themen zurück, die gewirkt haben. */
export function polarEffect(pos: Record<string, number> | undefined, scale = 1): string[] {
  if (!since(3) || !pos) return [];
  const hit: string[] = [];
  for (const a in pos) {
    const v = pos[a] || 0; if (!POLAR.has(a) || Math.abs(v) < .5) continue;
    const lean = LEAN[a] || {};
    for (const g in lean) S.bonus[g] = (S.bonus[g] || 0) + clamp(v, -2, 2) * (lean as any)[g] * POL_K * scale;
    (S as any).polar = clamp(polar() + Math.abs(v) * 3.5 * scale, 0, 100);
    hit.push(a);
  }
  return hit;
}

/** Beim Inkrafttreten eines Gesetzes. */
export function polarEnact(L: any) {
  const hit = polarEffect(L.fx?.pos);
  if (hit.length) log(`„${L.t}“ spaltet das Land (${hit.map((a) => AXN[a]).join(', ')}). Die einen jubeln, die anderen sind empört.`, '');
}

/** Monatlich: Spaltung klingt ab, mobilisiert die Basis und kostet allgemeine Zustimmung. */
export function polarTick() {
  if (!since(3)) return;
  const p = polar(); if (p <= 0) return;
  for (const g in S.bonus) S.bonus[g] -= p * POL_COST;
  S.basis = Math.min(3, (S.basis || 0) + p * .0004);
  (S as any).polar = Math.max(0, p * .985 - .2);
}

/** Einordnung für die Anzeige. */
export const polarLabel = (p: number) => (p < 15 ? 'gering' : p < 35 ? 'spürbar' : p < 60 ? 'hoch' : 'sehr hoch');
